/* Etiquetas multiidoma en inglés. */
export default {
  "bookingListItem.CANCELLED": "Cancelled",
  "bookingListItem.CONFIRMED": "Confirmed",
  "bookingListItem.ON_REQUEST": "On Request",
  "bookingListItem.result.empty": "No results",
};
